module.exports = __webpack_public_path__ + "static/media/marin_edited.2af7d109.JPG";